import { render, staticRenderFns } from "./ClientDocumentPreview.vue?vue&type=template&id=79b4ae6d&"
import script from "./ClientDocumentPreview.vue?vue&type=script&lang=js&"
export * from "./ClientDocumentPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports